'use strict';

const _ = require('lodash');

const Enum = require('./enum');

/**
 * @enum {String}
 * @readonly
 */
const DataStores = {
  MONGO: 'mongo',
  DYNAMODB: 'dynamodb',
  S3: 's3',
};

module.exports = {
  DataStores: Object.create(
    Enum,
    _.transform(DataStores, (result, value, key) => (result[key] = { value, enumerable: true }))
  ),
};
